var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"upgrade-icon"}},[_c('v-tooltip',{attrs:{"top":"","max-width":"200px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"size":_vm.size,"color":"accentYellow"},on:{"click":_vm.setError}},'v-icon',attrs,false),on),[_vm._v(" mdi-rocket ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText || _vm.$t('views.common.upgradeIcon.onlyPlan')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }